import { computed, reactive } from 'vue';

const _state = reactive({
  instances: {},
});

export function useSharedState({ id }) {
  if (!_state.instances[id]) {
    _state.instances[id] = {};
  }

  const state = computed(() => {
    return _state.instances[id];
  });

  return {
    state: _state.instances[id],
  };
}
